export default function EyeIcon({ color = "currentColor" }) {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50033 3C6.96989 3 6.46118 3.21071 6.08611 3.58579C5.71104 3.96086 5.50033 4.46957 5.50033 5C5.50033 5.53043 5.71104 6.03914 6.08611 6.41421C6.46118 6.78929 6.96989 7 7.50033 7C8.03076 7 8.53947 6.78929 8.91454 6.41421C9.28961 6.03914 9.50033 5.53043 9.50033 5C9.50033 4.46957 9.28961 3.96086 8.91454 3.58579C8.53947 3.21071 8.03076 3 7.50033 3ZM7.50033 8.33333C6.61627 8.33333 5.76842 7.98214 5.1433 7.35702C4.51818 6.7319 4.16699 5.88406 4.16699 5C4.16699 4.11595 4.51818 3.2681 5.1433 2.64298C5.76842 2.01786 6.61627 1.66667 7.50033 1.66667C8.38438 1.66667 9.23223 2.01786 9.85735 2.64298C10.4825 3.2681 10.8337 4.11595 10.8337 5C10.8337 5.88406 10.4825 6.7319 9.85735 7.35702C9.23223 7.98214 8.38438 8.33333 7.50033 8.33333ZM7.50033 0C4.16699 0 1.32033 2.07333 0.166992 5C1.32033 7.92667 4.16699 10 7.50033 10C10.8337 10 13.6803 7.92667 14.8337 5C13.6803 2.07333 10.8337 0 7.50033 0Z"
        fill={color}
      />
    </svg>
  );
}
